var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeviceUnknown(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "#5D6B72",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.87,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1H17C18.1 1 19 1.9 19 3V21C19 22.1 18.1 23 17 23H7C5.9 23 5 22.1 5 21V3C5 1.9 5.9 1 7 1ZM17 19V5H7V19H17ZM12 6.72C10.04 6.72 8.5 8.24 8.5 10.19H10.25C10.25 9.26 11.07 8.44 12 8.44C12.93 8.44 13.75 9.26 13.75 10.19C13.75 10.9566 13.2453 11.3528 12.6781 11.7982C11.9505 12.3695 11.12 13.0216 11.12 14.64H12.88C12.88 13.6949 13.4892 13.152 14.1201 12.5898C14.7975 11.9862 15.5 11.3602 15.5 10.19C15.5 8.23 13.96 6.72 12 6.72ZM13 18V16H11V18H13Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceUnknown);
export default __webpack_public_path__ + "static/media/device-unknown.3115c4f8.svg";
export { ForwardRef as ReactComponent };